import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import routes from '../routes';
import { getCookie } from '../utils/persistor';

const mapState = ({ userData }) => ({
  isLoggedIn: userData.profile.isLoggedIn,
});
const useAuth = () => {
  const history = useHistory();
  const { isLoggedIn } = useSelector(mapState);
  // const isLoggedInItem = localStorage.getItem('isLoggedIn');
  const isLoggedInCookie = getCookie('isLoggedIn');

  let restrictedIsLoggedIn = null;

  if (isLoggedInCookie !== 'true' && isLoggedInCookie !== 'false') {
    restrictedIsLoggedIn = 'false';
  } else {
    restrictedIsLoggedIn = isLoggedInCookie;
  }

  useEffect(() => {
    if (restrictedIsLoggedIn !== 'true') {
      history.push(routes.login);
    }
  }, [isLoggedIn]);

  // return isLoggedIn || isLoggedInItem || isLogged;
  return restrictedIsLoggedIn === 'true';
};

export default useAuth;
